import * as Constants from '../constants/auth';

const initialState = {
  authUser: {},
  isAdminUser: false,
  isSuperUser: false,
  isDeveloperUser: false,
  isKittyhawkSuperuser: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_AUTH_USER_SUCCESS: {
      let isAdminUser = false;
      let isSuperUser = false;
      let isDeveloperUser = false;
      let isKittyhawkSuperuser = false;

      action.payload.groups.forEach((group) => {
        if (group.name === 'Administrators') {
          isAdminUser = true;
        }
        if (group === 'Super Users') {
          isSuperUser = true;
        }
        if (group === 'Developer Users') {
          isDeveloperUser = true;
        }
        if (group === 'Kittyhawk Super Users') {
          isKittyhawkSuperuser = true;
        }
      });
      return {
        ...state,
        authUser: action.payload,
        isAdminUser,
        isSuperUser,
        isDeveloperUser,
        isKittyhawkSuperuser
      };
    }
    default:
      return state;
  }
};
